import React, { Fragment } from "react";
import "./cartitem.css";
import Button from "./../button/button";
const CartItem = ({ name, img, price, remove, product }) => {
  return (
    <Fragment>
      <div className="container_fluid">
        <div className="row cart_item_body">
          <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 item_image">
            <img src={img} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 cart_item_detail">
            <div className="cart_item_name">{name}</div>
            <div className="cart_item_price">{price}</div>
          </div>
          <div
            className="col-xs-12 col-sm-12 col-md-8 col-lg-86 col-xl-8 remove_item_btn"
            onClick={() => remove(product)}
          >
            <Button
              boxShadow="0px 0px 13px -3px #636e72"
              background="#d63031"
              color="white"
              heigh="35px"
              width="140px"
              radius="23px"
              padding="0 5px"
            >
              حذف از سبد
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CartItem;
